import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import TermsAndConditionsDisplay from '../../../components/terms/TermsAndConditionsDisplay';
import { PRIMARY_LINK_CLASS_NAME } from '../../../theme/constants/link';
import { BORDERED_BACKGROUND_STACK_CLASS_NAME } from '../../../theme/constants/stack';

const TermsTyCStep = ({ onNext, isSubmitting, privacyPolicyUrl }) => {
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [acceptDataUsage, setAcceptDataUsage] = useState(false);
  const [acceptPrivacyPolicy, setAcceptPrivacyPolicy] = useState(false);

  const canContinue = acceptTerms
    && acceptDataUsage
    && (!privacyPolicyUrl || acceptPrivacyPolicy);

  return (
    <Stack flex={1} minHeight={0}>
      <Typography variant="medium_1" fontWeight={700} color="gray.main">
        Para continuar, lee y acepta los términos y condiciones
      </Typography>

      <Stack
        direction="row"
        className={BORDERED_BACKGROUND_STACK_CLASS_NAME}
        flex={1}
        minHeight={300}
        marginTop={5}
        padding={3}
      >
        <Grid container height="100%">
          <Grid item xs={12} md={12} height="100%">
            <TermsAndConditionsDisplay withBackground={false} />
          </Grid>
        </Grid>
      </Stack>

      <Stack direction="column" spacing={0} marginTop={2} alignItems="flex-start">
        {privacyPolicyUrl && (
          <FormControlLabel
            control={(
              <Checkbox
                checked={acceptPrivacyPolicy}
                onChange={(e) => setAcceptPrivacyPolicy(e.target.checked)}
              />
            )}
            label={(
              <Typography variant="small_3">
                <Link
                  className={PRIMARY_LINK_CLASS_NAME}
                  href={privacyPolicyUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => e.stopPropagation()}
                >
                  He leído la política de privacidad y protección de datos
                </Link>
              </Typography>
            )}
          />
        )}
        <FormControlLabel
          control={(
            <Checkbox
              checked={acceptTerms}
              onChange={(e) => setAcceptTerms(e.target.checked)}
            />
          )}
          label={(
            <Typography variant="small_3">
              Acepto los términos y condiciones
            </Typography>
          )}
        />
        <FormControlLabel
          control={(
            <Checkbox
              checked={acceptDataUsage}
              onChange={(e) => setAcceptDataUsage(e.target.checked)}
            />
          )}
          label={(
            <Typography variant="small_3">
              Doy mi consentimiento de uso de datos
            </Typography>
          )}
        />
      </Stack>

      <Button
        variant="contained"
        sx={{ mt: 4, alignSelf: 'center' }}
        onClick={onNext}
        disabled={!canContinue || isSubmitting}
      >
        ACEPTAR Y CONTINUAR
      </Button>
    </Stack>
  );
};

TermsTyCStep.propTypes = {
  onNext: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
  privacyPolicyUrl: PropTypes.string,
};

TermsTyCStep.defaultProps = {
  isSubmitting: false,
  privacyPolicyUrl: null,
};

export default TermsTyCStep;
